module.exports = __webpack_public_path__ + "static/flags/HK-4f08a6a24936f1184366f575d3588622.gif";